import React, { Dispatch, SetStateAction } from 'react';
import { pushGtmEvent } from 'analytics/gtm';
import { MdOutlineBarChart, MdOutlineFormatListBulleted } from 'react-icons/md';
import { useMediaQuery } from 'react-responsive';

import { ToggleGroup } from 'design-system';

import { TypeReport } from '../../types';

type ViewModeFilterProps = {
  typeReport: TypeReport;
  setTypeReport: Dispatch<SetStateAction<TypeReport>>;
};

const ViewModeFilter: React.FC<ViewModeFilterProps> = ({
  typeReport,
  setTypeReport,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <ToggleGroup
      label="Modo de visualização:"
      value={typeReport}
      onChange={(value) => {
        pushGtmEvent({
          event: 'click_cta',
          eventCategory: 'home',
          eventAction: 'click',
          eventLabel: 'Modo de Visualização',
          pageSection: 'home',
          elementType: 'button',
        });
        setTypeReport(value as TypeReport);
      }}
      size={isMobile ? 'sm' : 'md'}
      activeColor="#000FFF"
      borderColor="#d9d9d9"
      color="#8c8c8c"
      items={[
        {
          value: 'graph',
          icon: <MdOutlineBarChart />,
          label: 'Gráfico',
        },
        {
          value: 'list',
          icon: <MdOutlineFormatListBulleted />,
          label: 'Lista',
        },
      ]}
    />
  );
};

export default ViewModeFilter;
